import React from 'react'
import styled from 'styled-components'

import { Columns, DiscoverMore, H2, Image, Screen, Section } from 'ui'

const Title = styled(H2) `
  margin-top: 12px;
  margin-bottom: 23px;

  font-size: 20px;
  font-weight: normal;
  letter-spacing: 1px;
  text-align: left;

  @media screen and (max-width: 640px) {
    text-align: center;
    margin-bottom: 42px;
  }
`

const Container = styled(Section.Light) `
  padding-bottom: 67px;

  @media screen and (max-width: 640px) {
    padding-top: 18px;
    padding-bottom: 52px;
  }
`

const ServiceContainer = styled(Columns.Column) `
  display: flex;
  flex-direction: column;
`

const Service = ({ image, name }) => (
  <ServiceContainer>
    <Image src={ image } />
    <Title>{name }</Title>
  </ServiceContainer>
)

const Services = () => (
  <Container>
    <Screen>
      <Columns>
        <Service image="/images/home/golden-compass" name="Awards and Mentions winning professionist" />
        <Service image="/images/home/brand" name="Brand identity, Graphic Design and Image postproduction" />
      </Columns>
      <Columns>
        <Service image="/images/home/marketing" name="Marketing, Luxury Marketing and Brand development" />
        <Service image="/images/home/events" name="Communication strategy and Events" />
      </Columns>
      <DiscoverMore />
    </Screen>
  </Container>
)

export default Services
